
import axios from 'axios';

const TOKEN_KEY = 'dicom_platform_token';
const USER_KEY = 'dicom_platform_user';

// Vite production API URL
// Add VITE_API_URL to .env.production
const API_URL = import.meta.env.VITE_API_URL || 'https://dicom.s3dwebtech.in';

const client = axios.create({
  baseURL: `${API_URL}/api/auth`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Get authentication token
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

// Get stored user safely
export function getStoredUser() {
  const raw = localStorage.getItem(USER_KEY);

  if (!raw || raw === 'undefined' || raw === 'null') {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (error) {
    console.error('Invalid stored user data. Clearing session.', error);

    // Remove corrupted data so the application can recover
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(TOKEN_KEY);

    return null;
  }
}

// Store login/register session
function storeSession(token, user) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }

  if (user !== undefined && user !== null) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  } else {
    localStorage.removeItem(USER_KEY);
  }
}

// Clear login session
export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

// Login
export async function login(username, password) {
  const { data } = await client.post('/login', {
    username,
    password,
  });

  if (!data || !data.token) {
    throw new Error('Login failed: authentication token was not returned by the server.');
  }

  storeSession(data.token, data.user);

  return data.user;
}

// Register
export async function register(username, password) {
  const { data } = await client.post('/register', {
    username,
    password,
  });

  if (!data || !data.token) {
    throw new Error('Registration failed: authentication token was not returned by the server.');
  }

  storeSession(data.token, data.user);

  return data.user;
}

export default client;

